import { render, staticRenderFns } from "./m-batch-list.vue?vue&type=template&id=eb72f81e&scoped=true&"
import script from "./m-batch-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-batch-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-batch-list.vue?vue&type=style&index=0&id=eb72f81e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb72f81e",
  null
  
)

export default component.exports